"use client";
import mixpanel from "mixpanel-browser";
import { isOpenRemunerationPlan } from "../plans";
import environmentVariables from "../enviromentVariables/index.js.erb";
let isInitialized = false;
let debugLogged = false;
let lastTrackTime = 0;
const TRACK_THROTTLE_MS = 100;

export const initializeMixpanelTracking = (token) => {
  if (!isInitialized) {
    // Check if token is valid
    if (!token || token === "undefined" || token === "null") {
      console.log("[Mixpanel] Invalid token provided, skipping initialization");
      return;
    }

    try {
      mixpanel.init(token, {
        autocapture: false,
        api_host: "https://api-eu.mixpanel.com",
        app_host: "https://eu.mixpanel.com",
        loaded: () => {
          isInitialized = true;
        },
      });
    } catch (error) {
      console.log("[Mixpanel] Initialization failed:", error);
      isInitialized = false;
    }
  }
};

const EXCLUDED_EMAILS = [
  "kimjcanastra@gmail.com",
  "djoygwapa@gmail.com",
  "janicecornelia@gmail.com",
  "mpinkienineria@gmail.com",
  "ernie09301989@gmail.com",
  "ib_lofranco+1@hotmail.com",
  "nataliehoang713@gmail.com",
  "donald+1@bigfuture.com.au",
  "aniket@opendirector.com.au",
  "daan.vanrumund@gmail.com",
  "ib_lofranco@hotmail.com",
  // add more as needed
];

export const mixpanelTrack = (eventName, props = {}) => {
  const now = Date.now();
  if (now - lastTrackTime < TRACK_THROTTLE_MS) {
    return;
  }
  lastTrackTime = now;

  // Safety check for mixpanel initialization
  if (!mixpanel || typeof mixpanel.track !== "function") {
    console.log(
      "[Mixpanel] Mixpanel not initialized, skipping tracking:",
      eventName
    );
    return;
  }

  // Environment check - skip tracking in local and staging
  const currentEnv = environmentVariables?.release_state;
  if (currentEnv === "staging" || currentEnv === "development") {
    if (!debugLogged) {
      console.log(
        `[Mixpanel] Skipping tracking in ${currentEnv} environment:`,
        eventName
      );
      debugLogged = true;
    }
    return;
  }

  // User email check - skip tracking for excluded emails
  const userEmail =
    props.userEmail || (window.currentUser && window.currentUser.email);
  if (userEmail && EXCLUDED_EMAILS.includes(userEmail)) {
    console.log(`[Mixpanel] Skipping tracking for excluded user: ${userEmail}`);
    return;
  }

  // Additional safety check for mixpanel internal state
  try {
    // Track the event
    mixpanel.track(eventName, props);
  } catch (error) {
    console.log("[Mixpanel] Error tracking event, skipping:", eventName, error);
  }
};

export const setMixpanelUser = (user) => {
  if (!user) return;

  // Safety check for mixpanel initialization
  if (!mixpanel || typeof mixpanel.identify !== "function") {
    console.log("[Mixpanel] Mixpanel not initialized, skipping user setup");
    return;
  }

  try {
    const isOpenRemuneration = isOpenRemunerationPlan(user);
    const distinctId = user.email || user.id || "anonymous";

    const currentDistinctId = mixpanel.get_distinct_id();

    if (currentDistinctId !== distinctId) {
      mixpanel.identify(distinctId);
    }
    mixpanel.people.set({
      $email: user.email,
      $name: user.email || user.id,
      app_name: isOpenRemuneration ? "Open Remuneration" : "Open Director",
      user_id: user.id,
    });
  } catch (error) {
    console.log("[Mixpanel] Error setting user, skipping:", error);
  }
};

// Reset debug flag for testing purposes
export const resetMixpanelDebug = () => {
  debugLogged = false;
  lastTrackTime = 0;
};

export { mixpanel };
